import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../Shared/Icons';

// ── Chess bottom navigation ─────────────────────────────────────────────
// Persistent bottom bar across the chess section so everything is one tap
// away — modern mobile-app navigation with Iyanna's own identity.

const TABS = [
  { id: 'home', path: '/chess', icon: 'home', label: 'Home' },
  { id: 'puzzle', path: '/chess/puzzle', icon: 'puzzle', label: 'Puzzle' },
  { id: 'rank', path: '/chess/ranking', icon: 'trophy', label: 'Rank' },
  { id: 'watch', path: '/chess/watch', icon: 'play', label: 'Live' },
  { id: 'profile', path: '/chess/profile', icon: 'user', label: 'Profile' },
];

export default function ChessNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  function isActive(tab) {
    if (tab.path === '/chess') return pathname === '/chess';
    return pathname.startsWith(tab.path);
  }

  return (
    <div style={styles.bar}>
      {TABS.map(tab => {
        const active = isActive(tab);
        return (
          <button
            key={tab.id}
            style={styles.tab}
            onClick={() => navigate(tab.path)}
          >
            <div style={{
              ...styles.iconWrap,
              background: active ? 'rgba(16,185,129,0.16)' : 'transparent',
            }}>
              <Icon
                name={tab.icon}
                size={20}
                color={active ? '#34D399' : 'rgba(255,255,255,0.45)'}
                strokeWidth={active ? 2.2 : 1.8}
              />
            </div>
            <div style={{
              ...styles.label,
              color: active ? '#34D399' : 'rgba(255,255,255,0.45)',
              fontWeight: active ? '800' : '600',
            }}>
              {tab.label}
            </div>
          </button>
        );
      })}
    </div>
  );
}

// Pages that show this nav should add paddingBottom: '86px' to their page
// container so content never hides behind the bar.
const styles = {
  bar: {
    position: 'fixed', left: '50%', transform: 'translateX(-50%)',
    bottom: 'calc(14px + env(safe-area-inset-bottom))', zIndex: 900,
    width: 'calc(100% - 28px)', maxWidth: '440px',
    display: 'flex', justifyContent: 'space-around', alignItems: 'stretch',
    background: 'rgba(22,27,25,0.92)',
    border: '1px solid rgba(255,255,255,0.09)',
    borderRadius: '22px',
    backdropFilter: 'blur(16px)',
    boxShadow: '0 12px 34px rgba(0,0,0,0.45)',
    padding: '9px 6px',
  },
  tab: {
    flex: 1, background: 'transparent', border: 'none', cursor: 'pointer',
    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px',
    fontFamily: 'inherit', padding: '2px 0',
  },
  iconWrap: {
    width: '40px', height: '28px', borderRadius: '9px',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  label: { fontSize: '9.5px', letterSpacing: '0.2px' },
};
